export default "/images/arrow-up-right.svg?4b0c4ca14e1f2518756800e68379841b";